import * as errorTexts from '../../const/ErrorMessages/ComplaintErrorMessages';

export function validateComplaintType(complaintType) {
    let validationResult = {
        error: null,
        isFromValid: true
    };
    validateType(complaintType, validationResult);
    return validationResult;
} 

export function validateIsAnyPosition(complaintPositions) {
    let validationResult = {
        error: null,
        isFromValid: true
    };
    validateThatComplaintPositionsExists(complaintPositions, validationResult);
    return validationResult;
}

function validateThatComplaintPositionsExists(complaintPositions, validationResult) {
    if (complaintPositions.length < 1 ){
        validationResult.isFromValid = false;
        validationResult.error = errorTexts.NO_POSITIONS;
    }
    return validationResult;
}

function validateType(complaintType, validationResult) {
    if (complaintType==='Warranty'){
        validationResult.isFromValid = false;
        validationResult.error = errorTexts.UNSELECTED_COMPLAINT_TYPE;
    }
    return validationResult;
}


// WEBPACK FOOTER //
// ./src/actions/Validators/ComplaintValidator.js